import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";

export default class InputWithButton extends Component {
  render() {
    const { onClickIcon, id, icon, buttonText, readOnly, onClear, disableInput, disableButton, ...rest } =
      this.props;

    return (
      <FlexView vAlignContent="center" style={{ flex: 1 }}>
        <div style={{ position: "relative", flex: 1 }}>
          <SimpleInput {...rest} readOnly={disableInput} />
          {onClear && (
            <SimpleButton
              styles={{ position: "absolute", right: 10, top: "33%" }}
              category="action_button"
              onClick={() => onClear()}
              icon={<i className="fa fa-md fa-times" />}
            />
          )}
        </div>
        <SimpleButton
          id={`btn_action_input_with_button_${id}`}
          styles={{ width: "auto" }}
          icon={icon}
          secondary={disableButton}
          disabled={disableButton}
          text={buttonText}
          onClick={onClickIcon}
        />
      </FlexView>
    );
  }
}
